/**
 * Determines if the application is running on a local development environment.
 *
 * This function performs runtime detection based on:
 * - Hostname contains 'local.profet.ai'
 * - Port is 4200 (Angular dev server default port)
 * - Localhost variations (localhost, 127.0.0.1)
 *
 * This allows developers to run any environment configuration locally
 * (dev/qa/staging/prod) without manually editing environment files.
 *
 * @returns {boolean} true if running locally, false otherwise
 */
export function isRunningLocally(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const hostname = window.location.hostname;
  const port = window.location.port;

  // Check if running on local development server
  const isLocalHost =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '0.0.0.0' ||
    hostname.endsWith('.local') ||
    hostname.includes('local.profet.ai');

  // Dev server typically runs on port 4200
  const isDevPort = port === '4200' || port === '4201' || port === '4202';

  return isLocalHost || isDevPort;
}

/* Gets the application frontend URL based on runtime environment. */
export function getAppFrontendUrl(deployedUrl: string): string {
  return isRunningLocally() ? 'https://valuation.local.profet.ai:4200' : deployedUrl;
}

/* Gets the login URL based on runtime environment. */
export function getLoginUrl(deployedLoginUrl: string): string {
  return isRunningLocally() ? 'https://valuation.local.profet.ai:4200/login' : deployedLoginUrl;
}

/* Gets the auth cookie storage domain based on runtime environment. */
export function getCookieDomain(deployedDomain: string): string {
  return isRunningLocally() ? 'local.profet.ai' : deployedDomain;
}
